module.exports = __webpack_public_path__ + "img/couples-090.d0ed0d22.jpg";